import { create } from 'zustand';
import type { ToastState } from '../types';

interface UIState {
  // Toast state
  toast: ToastState;
  showToast: (message: string, type?: ToastState['type']) => void;
  hideToast: () => void;

  // Sidebar state (for mobile)
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;

  // Modal state
  modalOpen: string | null;
  openModal: (id: string) => void;
  closeModal: () => void;

  // Dark mode state
  darkMode: boolean;
  setDarkMode: (enabled: boolean) => void;
  toggleDarkMode: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  // Toast
  toast: {
    isOpen: false,
    message: '',
    type: 'info',
  },
  showToast: (message: string, type: ToastState['type'] = 'info') => {
    set({
      toast: {
        isOpen: true,
        message,
        type,
      },
    });

    // Auto-hide after 3 seconds
    setTimeout(() => {
      set((state) => ({
        toast: { ...state.toast, isOpen: false },
      }));
    }, 3000);
  },
  hideToast: () => {
    set((state) => ({
      toast: { ...state.toast, isOpen: false },
    }));
  },

  // Sidebar
  sidebarOpen: false,
  toggleSidebar: () => {
    set((state) => ({ sidebarOpen: !state.sidebarOpen }));
  },
  setSidebarOpen: (open: boolean) => {
    set({ sidebarOpen: open });
  },

  // Modal
  modalOpen: null,
  openModal: (id: string) => {
    set({ modalOpen: id });
  },
  closeModal: () => {
    set({ modalOpen: null });
  },

  // Dark mode (default: true - sötét mód alapértelmezett)
  darkMode: true,
  setDarkMode: (enabled: boolean) => {
    set({ darkMode: enabled });
    if (enabled) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  },
  toggleDarkMode: () => {
    set((state) => {
      const newDarkMode = !state.darkMode;
      if (newDarkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      return { darkMode: newDarkMode };
    });
  },
}));
